import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/landing/software-app-development/cmore-back.webp";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Cmorecase() {
  return (
    <section
      className="casestudy-lp  yeppy-case text_white"
      style={{ background: "#000" }}
    >
      <Container>
        <div
          className="case-box"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <Row>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto mb-4 mb-md-0"
            >
              <div className="logo">
                <StaticImage
                  src="../../../images/landing/software-app-development/cmore-logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={120}
                  height={104}
                />
              </div>
              <h2>Empowering Construction with C-More Supply</h2>
              <p>
                The primary goal behind CMORE is to build a technologically
                advanced and tailored e-commerce solution that specifically
                meets the unique needs of construction material stores and
                builders.
              </p>
              <Link
                style={{ background: "#f47a14", color: "#fff" }}
                href="#getform"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                View Case Study
              </Link>
            </Col>
            <Col
              xs={12}
              md={5}
              lg={5}
              xl={5}
              xxl={5}
              className="offset-md-1 my-xl-auto text-center"
            >
              <StaticImage
                src="../../../images/landing/software-app-development/cmore-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={769}
                height={431}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Cmorecase;
